import { render, staticRenderFns } from "./EditInvoiceComment.vue?vue&type=template&id=09e22a7d&"
import script from "./EditInvoiceComment.vue?vue&type=script&lang=js&"
export * from "./EditInvoiceComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports